import html2canvas from 'html2canvas';
import { message } from 'antd';

export function toCanvas(captureId: string, saveFileName: string) {
  return new Promise((resolve) => {
    html2canvas(
      // @ts-ignore
      document.getElementById(captureId),
      {
        useCORS: true, 
        allowTaint: true,
      }).then((canvas:any) => {  
        // @ts-ignore
          console.log(document.getElementsByTagName('canvas'))
          const oA = document.createElement("a");
          oA.download = saveFileName;
          oA.href = canvas.toDataURL();
          document.body.appendChild(oA);
          oA.click();
          oA.remove();
        resolve(canvas);
      }).then(() => {
        message.success('保存成功')
      })
  })

}

// 把image 转换为 canvas对象  
export function convertImageToCanvas(image: any) { 
  return new Promise(( resolve, reject ) => {
    var canvas = document.createElement("canvas"); 

    var img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = image;
    img.onload = function(){
      // 如果图片是过宽的
      if ((img.width / img.height) > (305 / 243)) {
        canvas.height = img.height;
        const finalWidth  = img.height * 305 / 243;
        canvas.width = finalWidth;
      } 

      // 如果图片过长
      if ((img.width / img.height) < (305 / 243)) {
        canvas.width = img.width;
        canvas.height = img.width * 243 / 305
      }

      // @ts-ignore  
      canvas.getContext("2d").drawImage(img, 0, 0);

      resolve(canvas.toDataURL("image/jpeg")); 
    }
    if (img) {
      img.onerror = function() {
        reject('图片解析失败')
      }
    }
  })
}  

/**
 * 画原价的line-through 因为canvas画出来的line-through位置不对
 */

export function drawLineThrough() {
  const targetEl: HTMLElement | null = document.querySelector("span.c-preview__info--original")
  const lineEl: HTMLElement | null = document.querySelector('#line-canvas');

  if (targetEl && lineEl) {
    lineEl.style.width = String(targetEl.clientWidth) + "px";
  }
}